<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Inicio</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page lcu-page-noSpacing">
            <HeroBanner :image="'/assets/heroes/LCU-Graduate-HD.jpg'">
                <section class="section">
                    <div class="col-1-thirds">
                        <div />
                        <div>
                            <div class="row">
                                <h3 class="lcu-hero-h3">
                                    LEGACY CHRISTIAN UNIVERSITY
                                </h3>
                            </div>
                            <div class="row">
                                <h1 class="lcu-hero-h1">
                                    Formando líderes con carácter, excelencia y propósito
                                </h1>
                            </div>
                            <div class="row">
                                <span class="lcu-header-text lcu-white-text">
                                    Nuestro compromiso es acompañarte, enseñarte y prepararte
                                    para la obra del ministerio con excelencia
                                </span>
                            </div>
                        </div>
                    </div>
                </section>
            </HeroBanner>
            <section class="section-public-gray no-padding-bottom">
                <div class="section-container">
                    <div class="lcu-homepage-colBox">
                        <div class="lcu-homepage-col3">
                            <div class="lcu-homepage-iconCols">
                                <img class="lcu-homepage-iconImg" src="/assets/icons-svg/clock.svg" alt="Clock icon" />
                                <div class="lcu-homepage-textCol">
                                    <span class="lcu-homepage-textColHead">Estudia a tu ritmo</span>
                                    <span class="lcu-homepage-textColSpan">Tú decides cuando estudiar</span>
                                </div>
                            </div>
                            <div class="lcu-homepage-iconCols">
                                <img class="lcu-homepage-iconImg" src="/assets/icons-svg/cert.svg" alt="Certificate icon" />
                                <div class="lcu-homepage-textCol">
                                    <span class="lcu-homepage-textColHead">Completa tu licenciatura</span>
                                    <span class="lcu-homepage-textColSpan">En tan solo un año</span>
                                </div>
                            </div>
                            <div class="lcu-homepage-iconCols">
                                <img class="lcu-homepage-iconImg" src="/assets/icons-svg/tassle.svg" alt="Cap icon" />
                                <div class="lcu-homepage-textCol">
                                    <span class="lcu-homepage-textColHead">Gradúate</span>
                                    <span class="lcu-homepage-textColSpan">Y obtén tu diploma</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="lcu-homepage-columns">
                        <div class="lcu-homepage-col1" :style="{ 'background-image': 'url(/assets/heroes/LCU-Image-Home-1.jpg)' }" />
                        <div class="lcu-homepage-col2">
                            <div class="row">
                                <h2 class="lcu-h2 lcu-h2-secondary">
                                    La Experiencia LCU
                                </h2>
                            </div>
                            <div class="row">
                                Legacy Christian University ofrece programas en línea y de extensión
                                diseñados para proporcionar una formación integral en Teología Bíblica,
                                Impartición y Revelación de la Palabra de Dios, en los niveles de
                                Licenciatura, Maestría y Doctorado
                            </div>
                            <div class="row">
                                <div>
                                    <button-cta
                                        :text="'Acerca de LCU'"
                                        :type="'secondary'"
                                        :class="['lcu-mobile-wideBtn']"
                                        @on-click="$router.push('/acerca-de-lcu')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-public-gray no-padding-bottom">
                <div class="section-container">
                    <div class="col-grid-2 col-homepage-col2">
                        <div class="lcu-col-center col-homepage-colItem">
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Clases en línea, pero no estarás solo
                                </h2>
                            </div>
                            <div class="row">
                                Recibirás mentoría personalizada, conocerás a un equipo
                                de profesores y formarás parte de una familia de fe,
                                con amistades que durarán toda la vida. 
                            </div>
                            <div class="row">
                                <div>
                                    <button-cta
                                        :text="'Ver el curriculum'"
                                        :type="'secondary'"
                                        border
                                        :class="['lcu-mobile-wideBtn']"
                                        @on-click="$router.push('/plan-de-estudios')" />
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-homepage-colItem"
                            :style="{ 'background-image': 'url(/assets/heroes/LCU-Image-Home-2.jpg)' }" />
                    </div>
                </div>
            </section>
            <section class="section-public-gray">
                <div class="section-container">
                    <div class="col-grid-2 col-homepage-col2">
                        <div
                            class="col-homepage-colItem2"
                            :style="{ 'background-image': 'url(/assets/heroes/LCU-Image-Home-3.jpg)' }" />
                        <div class="lcu-col-center col-homepage-colItem2">
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Estudia a tu propio ritmo
                                </h2>
                            </div>
                            <div class="row">
                                Puedes completar toda tu licenciatura en un año, a tu ritmo, desde
                                tu celular usando nuestra app o desde tu computadora ingresando
                                a tu cuenta.
                            </div>
                            <div class="row">
                                <div>
                                    <button-cta
                                        :text="'Descarga el app'"
                                        :type="'secondary'"
                                        border
                                        :class="['lcu-mobile-wideBtn']"
                                        @on-click="$router.push('/iniciar-sesion')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <HeroBanner
                :image="'/assets/heroes/LCU-Deepblue-classroom.jpg'"
                :style="{ 'min-height': '500px' }">
                <section class="section">
                    <div class="row">
                        <button
                            class="lcu-play-btn"
                            type="button"
                            @click.prevent="videoModal = true"
                            aria-label="Play button">
                            <img
                                class="lcu-playImg-center"
                                src="/assets/play-button.svg"
                                alt="Play button image" />
                        </button>
                    </div>
                    <div class="row">
                        <h3 class="lcu-h2 lcu-h2-secondary lcu-center-text">
                            No estás aquí por casualidad
                        </h3>
                    </div>
                    <div class="row">
                        <h1 class="lcu-hero-h3 lcu-center-text lcu-white-text">
                            Estás aquí porque Dios te trajo, y nuestra misión es ayudarte
                            a desarrollar lo que Él depositó en ti.
                        </h1>
                    </div>
                </section>
            </HeroBanner>
            <section class="section-public">
                <div class="section-container">
                    <div class="row">
                        <h3 class="lcu-hero-h3 lcu-center-text">
                            LEGACY CHRISTIAN UNIVERSITY
                        </h3>
                    </div>
                    <div class="row">
                        <h1 class="lcu-section-h1 lcu-center-text">
                            ¡Tu futuro ministerial comienza aquí!
                        </h1>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            <button-cta
                                :text="'Aplicar'"
                                @on-click="$router.push('/inscribirse')" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
    <Modal v-model="videoModal" :close="() => { videoModal = false; }">
        <div class="lcu-modal lcu-modal-wide">
        <video-player
            :options="{
            controls: true,
            sources: [
                {
                src: `${WEB_ASSETS_URL}/public-assets/lcu-welcome-video.mp4`,
                type: 'video/mp4'
                }
            ]
            }" />
        </div>
    </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import HeroBanner from '@/components/hero-banner/HeroBanner.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import VideoPlayer from 'ç/video-player/VideoPlayer.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';
import { WEB_ASSETS_URL } from '@/globals/constants';

export default {
  name: 'home-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    SecondaryNav,
    ButtonCta,
    Footer,
    MobileControls,
    IphoneBar,
    HeroBanner,
    VideoPlayer,
  },
  data() {
    return {
      videoModal: false,
      WEB_ASSETS_URL,
    };
  },
};
</script>

<style scoped lang="scss">
.lcu-col-center {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.lcu-playImg-center {
  width: 95px;
  height: 95px;
  align-self: center;
  justify-self: center;
}

.lcu-header-text {
  font-size: 16px;
}

.lcu-homepage-col3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 80px;
  align-items: center;

  @media only screen and (max-width: $tablet-max) {
    grid-template-columns: 1fr;
    grid-gap: 35px;
  }
}

.lcu-homepage-columns {
  display: grid;
  grid-template-columns: 55% 45%;
  min-height: 400px;
  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
  }
}

.lcu-homepage-col1 {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 200px;
}

.lcu-homepage-col2 {
  background-color: $legacy-primary;
  color: $white;
  padding: 40px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: $mobile-max) {
    padding: 30px;
  }
}

.lcu-homepage-colBox {
  background-color: $white;
  bottom: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 130px;
  padding: 20px 50px;
  position: absolute;
  width: 100%;

  @media only screen and (max-width: $tablet-max) {
    position: relative;
    bottom: auto;
    height: auto;
  }
}

.lcu-homepage-iconCols {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 25px;
  align-items: center;
}

.lcu-homepage-iconImg {
  height: 65px;
  width: 65px;
}

.lcu-homepage-textCol {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.lcu-homepage-textColHead {
  color: $legacy-primary;
  font-family: 'raleway-bold';
  font-size: 18px;
  margin-bottom: 5px;
}

.lcu-homepage-textColSpan {
  color: #878787;
}

.col-homepage-col2 {
  grid-gap: 0;
}

.col-homepage-colItem {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 400px;
  padding-right: 40px;

  &:first-child {
    @media only screen and (max-width: $mobile-max) {
      min-height: 0;
      padding-bottom: 75px;
      padding-right: 0;
    }
  }
}

.col-homepage-colItem2 {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 400px;
  padding-left: 40px;

  &:last-child {
    @media only screen and (max-width: $mobile-max) {
      min-height: 0;
      padding-bottom: 75px;
      padding-left: 0;
      order: 1,
    }
  }

  &:first-child {
    @media only screen and (max-width: $mobile-max) {
      order: 2,
    }
  } 
}

.no-padding-bottom {
  padding-bottom: 0;
}

.lcu-play-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;
}
</style>
